import { CalculateMulticoteSolutionsResultRequest } from "./../../../Models/ServerModels/Calculations/CalculateMulticoteSolutionsResultRequest";
import { CalculateMulticoteSolutionsResultResponse } from "./../../../Models/ServerModels/Calculations/CalculateMulticoteSolutionsResultResponse";
import Config from "../../../Configs";
import {
  ApiResponse,
  CalculateCustomizedSolutionProductResponse,
  CalculateRecommendedSolutionProductResponse,
  SavedItemsRequest,
  ChangeRecipeRequest,
  ChangeRecipeResponse,
} from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export default class CalculationsApiService extends ApiServiceBase {
  constructor(client: IHttpService) {
    super(client);
  }

  // agriSolution
  async calculateRecommendedSolutionProduct(data: SavedItemsRequest): Promise<ApiResponse<CalculateRecommendedSolutionProductResponse>> {
    return await this._client.post<CalculateRecommendedSolutionProductResponse>(Config.apiPaths.calculateRecommendedSolutionProduct, data);
  }

  // agriSolution
  async calculateCustomizedSolutionProduct(data: SavedItemsRequest): Promise<ApiResponse<CalculateCustomizedSolutionProductResponse>> {
    return await this._client.post<CalculateCustomizedSolutionProductResponse>(Config.apiPaths.calculateCustomizedSolutionProduct, data);
  }

  // solution
  async calculateMulticoteSolutionResults(
    data: CalculateMulticoteSolutionsResultRequest,
  ): Promise<ApiResponse<CalculateMulticoteSolutionsResultResponse>> {
    return await this._client.post<CalculateMulticoteSolutionsResultResponse>(Config.apiPaths.calculateMulticoteSolutionsResult, data);
  }

  async changeRecipe(data: ChangeRecipeRequest): Promise<ApiResponse<ChangeRecipeResponse>> {
    return await this._client.post<ChangeRecipeResponse>(Config.apiPaths.changeRecipe, data);
  }
}
